import { Component } from '@angular/core';

@Component({
  selector: 'app-colors',

  templateUrl: './colors.component.html',

  styleUrls: ['./colors.component.scss'],
})
export class ColorsComponent {
  blackScaleKey = 'black';
  blackScaleShades = Array.from(Array(5).keys(), (k) => (k + 1) * 100).reverse();
  greyScaleKey = 'grey';
  greyScaleShades = [...Array.from(Array(5).keys(), (k) => (k + 1) * 100).reverse(), 50];
  colorKeys = [
    'primary-blue',
    'primary-purple',
    'primary-teal',
    'primary-marigold',
    'secondary-royal-blue',
    'secondary-medium-blue',
    'secondary-light-blue',
    'success',
    'info',
    'warning',
    'error',
  ];
  colorShades = [...Array.from(Array(8).keys(), (k) => (k + 1) * 100).reverse(), 50, 25];

  constructor() {}
}
